/**
 * Calculates the minimal healthy weight (in kg) for a given height based on a BMI threshold.
 *
 * @param heightInCm - The person's height in centimeters.
 * @param minBMI - The BMI used to calculate the minimal weight (default: 18.5).
 * @returns The minimal weight in kilograms, rounded to one decimal place.
 */
export const calculateMinimalWeight = (
    heightInCm: number,
    minBMI = 18.5,
): number => {
    const heightInMeters = heightInCm / 100;
    const weight = minBMI * heightInMeters ** 2;
    return Math.round(weight * 10) / 10;
};
